import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';

import Keywords from './Keywords';
import Ranks from './WidgetRanks';
import ReviewAnalysis from './Reviews';
import Performance from './Performance';
import WidgetPerformance from './WidgetPerformance';
import PreHeader from '../PreHeader';
import Header from '../Header';

import {
  activeEntitySelector,
  quickViewDataSelector,
  quickViewSettingsSelector,
} from '../../../selectors';

const DefaultQVContent = ({ onClose }) => {
  const app = useSelector(activeEntitySelector);
  const data = useSelector(quickViewDataSelector);
  const { aqv, aqvDetails } = useSelector(quickViewSettingsSelector);

  const performance = data?.performance || {};
  const widgets = data?.widgets || {};

  return (
    <>
      <PreHeader app={app} onClose={onClose} />
      <div className="app-quick-view__scrollable-container">
        <Header app={app} widgets={widgets} settings={aqvDetails} onClose={onClose} />
        <WidgetPerformance app={app} widgets={widgets} settings={aqv.widgets} />
        <Ranks store={app.store} ref_no={app.ref_no} settings={aqv.widgets} />
        <Performance
          performance={performance}
          store={app.store}
          ref_no={app.ref_no}
          settings={aqv.performance}
        />
        <ReviewAnalysis store={app.store} ref_no={app.ref_no} settings={aqv.audience} />
        <Keywords store={app.store} ref_no={app.ref_no} settings={aqv.aso} />
      </div>
    </>
  );
};

DefaultQVContent.propTypes = {
  onClose: T.func.isRequired,
};

export default DefaultQVContent;
